// extracted by mini-css-extract-plugin
export var container = "Calculator-module--container--e1a9d";
export var fadeInAnimation = "Calculator-module--fadeInAnimation--95fc9";
export var hideMobile = "Calculator-module--hideMobile--3ce5d";
export var wrapper = "Calculator-module--wrapper--67954";